module.exports = __webpack_public_path__ + "static/img/PASS.fa2983e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PASS.png
// module id = uu/r
// module chunks = 18